import { JsonObject } from "../interface/json";

const d = window as any;

export const customFormService: any = {
  getCustomForm(info: JsonObject): any {
    const path = "api/customform/get";
    return d.$sk.$skxhr(path, info);
  },

  action(info: JsonObject): any {
    const path = "customForm/action";
    return d.$sk.$skxhr(path, info);
  },
  serchBusiness(info: JsonObject): any {
    const path = "api/business/search";
    return d.$sk.$skxhr(path, info);
  },
};
